/**
 * RouteTracker — escuta mudanças de rota e dispara pageviews
 * para o Google Analytics 4 e o Meta Pixel.
 *
 * Deve ser renderizado uma única vez dentro do <BrowserRouter>.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initAnalytics, trackPageview, hasAnalytics } from '../lib/analytics';

const RouteTracker = () => {
  const location = useLocation();
  const privado = /^\/analise\/compartilhada\//.test(location.pathname) || /^\/p\/admin-hubworkconnect\/analises\//.test(location.pathname);

  useEffect(() => {
    if (!hasAnalytics() || privado) return;
    initAnalytics();
  }, [privado]);

  useEffect(() => {
    if (!hasAnalytics()) return;
    // Pequeno delay para garantir que document.title já foi atualizado pelo componente da página
    const t = setTimeout(() => trackPageview(location.pathname + location.search), 60);
    return () => clearTimeout(t);
  }, [location.pathname, location.search, privado]);

  return null;
};

export default RouteTracker;
